import type { QueryClient, QueryObserverOptions } from '@tanstack/react-query';
import type { Universe } from '@thinkalpha/platform-ws-client/contracts/universe.js';
import { getUniverses, getUniverseById } from 'src/lib/universes';

// Constants
export const UNIVERSES = 'universes';
export const ALL = 'all';

/**
 * Get a universe by ID.
 */
export function getUniverseByIdQuery(id: string): QueryObserverOptions<Universe | undefined> {
    return {
        queryKey: [UNIVERSES, id],
        queryFn: async () => await getUniverseById(id),
    };
}

/**
 * Get universes for a user.
 */
export function getUniversesQuery(): QueryObserverOptions<Universe[]> {
    return {
        queryKey: [UNIVERSES, ALL],
        queryFn: () => getUniverses(),
    };
}

/**
 * The last cached universes list, without fetching. Keeps the query key
 * private to this module so cache reads cannot drift from the query shape.
 */
export function getUniversesQueryData(queryClient: QueryClient): Universe[] | undefined {
    return queryClient.getQueryData<Universe[]>([UNIVERSES, ALL]);
}

/**
 * Gets the default universe from the list of universes
 */
export function getDefaultUniverseRecordQuery(): QueryObserverOptions<Universe[], unknown, Universe> {
    return {
        ...getUniversesQuery(),
        select: (universes) => universes.find((universe) => universe.default)!,
    };
}
